import type { OrganizationType } from '@form-factory/schema';
import { Role } from '@form-factory/schema/enums';
import { useLingui } from '@lingui/react/macro';
import { createFileRoute } from '@tanstack/react-router';
import { getQueryKey } from '@trpc/react-query';

import { TablePage } from '@/components/page/TablePage';
import { useOrganizationsCols } from '@/features/organizations';
import { useDetailRowHandler } from '@/hooks/useDetailRowHandler';
import { useTableQuery } from '@/hooks/useTableQuery';
import { trpc, trpcClient } from '@/services/trpc';

export const Route = createFileRoute('/_baseLayout/organizations/')({
  component: OrganizationsPage,
  beforeLoad: async ({ context: { accessGuard } }) =>
    accessGuard([Role.SuperAdmin]),
});

export function OrganizationsPage() {
  const { t } = useLingui();
  const columns = useOrganizationsCols();
  const handleQuery = useTableQuery(trpcClient.organizations.findAll.query);
  const handleRow = useDetailRowHandler<OrganizationType>(row => ({
    to: '/organizations/$organizationId/edit',
    params: {
      organizationId: row.original.id,
    },
  }));

  return (
    <TablePage
      title={t`Organizations`}
      breadcrumbs={[{ label: t`Organizations`, to: '/organizations' }]}
      createButton={{
        to: '/organizations/create',
        label: t`Create organization`,
      }}
      columns={columns}
      queryKey={getQueryKey(trpc.organizations.findAll)}
      onQueryFn={handleQuery}
      onRow={handleRow}
    />
  );
}
